import { Application } from "../../api/types";
import { DocumentDesignItemType, DocumentDesignState } from "./types";

/**
 * Remove corrupted or invalid data from the state.
 *
 * 1- Remove deleted fields from the state (fields that are not in the application structure).
 * 2- transform "anchored" elements with missing anchors to "absolute" elements.
 */
export function fixState(
  state: DocumentDesignState,
  application: Application,
): DocumentDesignState {
  const existingFieldSlugs = application.structure.map((field) => field.slug);

  let items = state.items
    // remove deleted fields from state
    .filter((item) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((item as any).field_slug) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return existingFieldSlugs.includes((item as any).field_slug);
      }

      return true;
    });

  // transform "anchored" elements with missing anchors to "absolute" elements
  items = items.map((item) => {
    if (item.position === "anchored") {
      const anchorItem = state.items.find((i) => i.id === item.anchorId);
      if (!anchorItem) {
        return {
          ...item,
          position: "absolute",
          anchorId: undefined,
          anchorDistance: undefined,
        };
      }
    }

    return item;
  });

  // transform "multipleSelect" elements with non-multipleSelect fields to "field" elements
  // this happens when multiple select field is migrated to a different field type
  items = items.map((item) => {
    if (item.type === DocumentDesignItemType.multipleSelect) {
      const field = application.structure.find(
        (field) => field.slug === item.field_slug,
      );
      if (field?.field_type !== "multipleselectfield") {
        return { ...item, type: DocumentDesignItemType.field, mode: undefined };
      }
    }

    return item;
  });

  return { ...state, items };
}
